import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const SdpService = ()=>{
    const [sdpService, setSdpService] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`sdpService?page=${page}`);
            
            setSdpService(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`sdpService/${id}`);
            setSdpService(sdpService.filter((sdpService) => sdpService.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'SdpService'}>
            <InnerNav createLink={'/sdpServiceCreate'} listLink={'/sdpService'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">ServiceName </th>
                                    <th className="px-4 py-3">ShortCode </th>
                                    <th className="px-4 py-3">OfferCode </th>
                                    <th className="px-4 py-3">Cost </th>
                                    <th className="px-4 py-3">Keyword </th>
                                    <th className="px-4 py-3">Client </th>
                                    <th className="px-4 py-3">ServiceType </th>
                                    <th className="px-4 py-3">ClientInputUrl </th>
                                    <th className="px-4 py-3">ClientDlrUrl </th>
                                    <th className="px-4 py-3">SdpInputUrl </th>
                                    <th className="px-4 py-3">SdpDlrUrl </th>
                                    <th className="px-4 py-3">CreatedAt </th>
                                    <th className="px-4 py-3">UpdateAt </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {sdpService.map((sdpService)=>{
                                         return(
                                             <tr key={sdpService.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{sdpService.id}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.service_name}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.short_code}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.offer_code}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.cost}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.keyword}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.client.name}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.service_type.name}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.client_input_url}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.client_dlr_url}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.sdp_input_url}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.sdp_dlr_url}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.created_at}</td>
                                                 <td className="px-4 py-3 text-sm">{sdpService.update_at}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/sdpService/${sdpService.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(sdpService.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default SdpService;